import React from 'react';
import {
  TextField,
  Button,
  ButtonProps,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { LocationDescriptor, Location } from 'history';

interface CustomTextFieldProps {
  name?: string;
  value: string | number | undefined | null;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  [key: string]: unknown;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  name,
  value,
  disabled,
  onChange,
  label,
  ...props
}) => {
  return (
    <TextField
      fullWidth
      name={name}
      value={value}
      {...(!disabled ? { onChange } : {})}
      variant="outlined"
      size="small"
      label={label}
      {...props}
    />
  );
};

interface CustomSelectProps {
  name?: string;
  value: unknown;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  [key: string]: unknown;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  name,
  value,
  onChange,
  placeholder,
  ...props
}) => {
  return (
    <TextField
      fullWidth
      name={name}
      value={value}
      onChange={onChange}
      select
      variant="outlined"
      size="small"
      placeholder={placeholder}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            sx: {
              maxHeight: 350,
              overflowY: 'auto',
              maxWidth: 300,
            },
          },
        },
      }}
      {...props}
    />
  );
};

interface CustomButtonProps extends ButtonProps {
  label?: string;
  to?:
    | LocationDescriptor<unknown>
    | ((location: Location<unknown>) => LocationDescriptor<unknown>);
}

const CustomButton: React.FC<CustomButtonProps> = ({ label, to, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Button
      variant="contained"
      fullWidth={isMobile}
      component={to ? Link : 'button'}
      to={to as unknown}
      {...props}
      sx={{
        margin: theme.spacing(0.5),
        width: isMobile ? '100%' : 200,
      }}
    >
      {label}
    </Button>
  );
};

export default CustomButton;

export { CustomTextField, CustomSelect, CustomButton };
